import React, { useContext, useState, useEffect } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { IModGroupChildItem, IGetModifiersForAssignResponse, IGetModifiersForAssignArguments } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getModifiersForAssign } from 'backend/modifierGroups';
import { ModifiersList } from './ModifiersList';

interface IProps {
	setChildren: (value: IModGroupChildItem[]) => void;
	modGroupId: string;
	restaurantId: Nullable<string>;
	IDsSelectedModifiers: string[];
	selectedChildren: IModGroupChildItem[];
}

export const ModifiersMultipleSelect: React.FC<IProps> = ({
	setChildren,
	modGroupId,
	restaurantId,
	IDsSelectedModifiers,
	selectedChildren,
}) => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const [fetchedModifiers, setFetchedModifiers] = useState<IGetModifiersForAssignResponse['data']['modifiers']>([]);

	const { response, loading, refetch, responseError } = useFetchData<
		IGetModifiersForAssignResponse['data'],
		IGetModifiersForAssignArguments
	>(modGroupId && restaurantId ? getModifiersForAssign : null, {
		modGroupId,
		restaurantId: restaurantId || '',
	});

	useEffect(() => {
		modGroupId && restaurantId && refetch();
	}, [modGroupId, restaurantId]);

	useEffect(() => {
		loading ? showLoader() : hideLoader();
	}, [loading]);

	useEffect(() => {
		if (response) {
			setFetchedModifiers(response.modifiers);
		}
	}, [response]);

	return (
		<ModifiersList
			setChildren={setChildren}
			refetch={refetch}
			responseError={responseError}
			IDsSelectedModifiers={IDsSelectedModifiers}
			availableModifiers={fetchedModifiers}
			selectedChildren={selectedChildren}
		/>
	);
};
